import { createContext, ReactNode } from 'react';
import { getToken, handleCCPermission, useAuth } from 'src/hooks';
import { IEnvironment } from 'src/interfaces';

import { AuthDataProviderProps } from './AuthProvider.interface';

export const AuthDataProvider = createContext<AuthDataProviderProps>({
  isLoading: true,
  isAuthenticated: false,
  environment: undefined,
  userRole: null,
});

export const AuthProvider = (props: {
  children: ReactNode;
  environment: IEnvironment | undefined;
}) => {
  const { children, environment } = props;
  const { isLoading, isAuthenticated } = useAuth();
  const userRole = handleCCPermission(getToken());

  return (
    <AuthDataProvider.Provider
      value={{
        isLoading,
        isAuthenticated,
        environment,
        userRole,
      }}>
      {children}
    </AuthDataProvider.Provider>
  );
};
